module.exports = __webpack_public_path__ + "static/media/centralized_service.b22bad78.svg";